var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJira(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_15442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1783 36.6574L42.54 16.0191L40.5398 14.0204L17.9029 36.6574C17.1629 37.3994 17.1629 38.6006 17.9029 39.3411L32.0964 53.5341L40.5398 61.9796L63.1783 39.3411C63.9188 38.6006 63.9188 37.3994 63.1783 36.6574ZM40.5398 45.0887L33.4509 38.0003L40.5398 30.9093L47.6303 38.0003L40.5398 45.0887Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5398 30.9093C35.8987 26.2662 35.875 18.7462 40.4904 14.0759L24.9742 29.5861L33.4196 38.0315L40.5398 30.9093Z",
    fill: "url(#paint0_linear_47_15442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6499 37.9801L40.5398 45.0887C42.7805 47.3273 44.0407 50.366 44.0407 53.5342C44.0407 56.7023 42.7805 59.7389 40.5398 61.9796L56.0934 46.4255L47.6499 37.9801Z",
    fill: "url(#paint1_linear_47_15442)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_15442",
    x1: 37.4926,
    y1: 25.5195,
    x2: 29.3736,
    y2: 33.6365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_15442",
    x1: 43.6747,
    y1: 50.4015,
    x2: 51.7774,
    y2: 42.2988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_15442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.9091,
    height: 48,
    fill: "white",
    transform: "translate(17 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.b2d62a192b7dae6f5b37b1541376057a.svg";
export { ForwardRef as ReactComponent };